import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PATH } from 'constants/path';
import StartStep from './components/StartStep';
import SetupStep from './components/SetupStep';
import WebinarBooking from 'components/WebinarBooking';
import { CALENDLY_LINK } from 'constants/common';
import { EWebinarScheduleType } from 'types/common';
import useBudgetInfo from 'hooks/marketing/useBudgetInfo';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import { getUrlParam, shouldUseKlarityUi } from 'utils/common';
import KlarityLogo from 'assets/logo/klarity.png';

const ProListingSetup = () => {
    const [searchParams] = useSearchParams();
    const [budgetInfo, budgetStatus] = useBudgetInfo();
    const navigate = useNavigate();
    const [step, setStep] = useState('start');
    const [showWebinarBooking, setShowWebinarBooking] = useState(false);
    const setupStepRef = useRef<any>(null);
    const [homeInfo, loadingHomeInfo, refetchHomeInfo] = useProviderHomeInfo();
    const showKlarityUi = shouldUseKlarityUi(homeInfo);

    // 根据URL参数设置step
    useEffect(() => {
        const type = searchParams.get('type');
        if (type === 'edit') {
            setStep('setup');
        } else {
            setStep('start');
        }
    }, [searchParams]);

    const Steps = [
        { key: 'start', component: <StartStep /> },
        { key: 'setup', component: <SetupStep ref={setupStepRef} /> },
    ];

    const handleNext = () => {
        if (step === 'start') {
            setStep('setup');
        } else {
            // 验证表单
            const isValid = setupStepRef.current?.validateForm();
            if (!isValid) {
                return;
            }
            setupStepRef.current?.handleSave();
        }
    };

    return (
        <div className={`${s.wrap} ${showKlarityUi ? s.wrapKlarity : ''}`}>
            <div className={s.header}>
                <div
                    className={s.logoWrap}
                    onClick={() => {
                        navigate(PATH.DASHBOARD);
                    }}
                >
                    {
                        !showKlarityUi &&
                        <img
                            src="https://saas-prod-us.s3.us-east-2.amazonaws.com/prod/ui/logo_kiwihealth_by_klarity_380x96.png"
                            className={s.logo}
                            alt="Kiwi Health Logo"
                        />
                    }
                    {
                        showKlarityUi &&
                        <img
                            src={KlarityLogo}
                            className={s.logoKlarity}
                            alt="Klarity Logo"
                        />
                    }

                </div>
                <Button type="primary" className={s.settingButton} onClick={() => setShowWebinarBooking(true)}>Talk to a Pro-Listings specialist</Button>
            </div>
            <div className={s.content}>
                {Steps.find((item) => item.key === step)?.component}
            </div>

            <div className={s.footer}>
                <div className={s.btns}>
                    <Button onClick={() => {
                        const from = getUrlParam('from');
                        if (from === 'financials') {
                            navigate(`${PATH.DASHBOARD}/${PATH.FINANCIALS}`);
                            return;
                        }
                        navigate(`${PATH.DASHBOARD}/${PATH.MARKETING}`);
                    }}
                    >Exit
                    </Button>
                    {step === 'setup' && <Button type="text" className={s.prevButton} onClick={() => setStep('start')}>Back</Button>}
                </div>
                <Button type="primary" className={s.exitButton} onClick={handleNext} disabled={step === 'setup' && budgetStatus.disableBudgetChange}>
                    {step === 'start' ? 'Next' : 'Save'}
                </Button>
            </div>
            <WebinarBooking
                modalHeader={(
                    <div className={s.wHeader}>
                        <div className={s.wTitle}>
                            Talk to a Pro-Listings specialist
                        </div>
                        <div className={s.wDesc}>Want to grow faster with pro listings? Book a time to speak with our specialist and get personalized guidance.</div>
                    </div>
                )}
                show={showWebinarBooking}
                link={CALENDLY_LINK.PRO_LISTINGS_SPECIALIST}
                webinarScheduleType={EWebinarScheduleType.PRO_LISTINGS_SPECIALIST}
                onClose={() => {
                    setShowWebinarBooking(false);
                }}
            />
        </div>
    );
};

export default ProListingSetup;
